import { useEffect } from "react";

import AmplitudeProvider from "~/AmplitudeProvider";
import { useCoinTransfersController } from "./CoinTransfers.controller";
import { CoinTransfersPresentation } from "./CoinTransfers.pres";

export const CoinTransfersConnector = () => {
  const props = useCoinTransfersController();

  useEffect(() => {
    AmplitudeProvider.dispatchPageVisit();
    window.dispatchEvent(
      new CustomEvent("load", {
        detail: { "amplitude-event-name": "coin_trasfer_page_visisted" },
      }),
    );
  }, []);

  return <CoinTransfersPresentation {...props} />;
};
